// Recovered compiled webpack factory 22758. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { AD: () => f, SB: () => s, hH: () => l, ul: () => c });
  var n = r(61571),
    a = r(43275);
  let o = /^o(\d+)\./,
    i = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
  function s(e, t = !1) {
    let { host: r, path: n, pass: a, port: o, projectId: i, protocol: l, publicKey: u } = e;
    return `${l}://${u}${t && a ? `:${a}` : ""}@${r}${o ? `:${o}` : ""}/${n ? `${n}/` : n}${i}`;
  }
  function l(e) {
    let t = i.exec(e);
    if (!t)
      return void (0, a.pq)(() => {
        console.error(`Invalid Sentry Dsn: ${e}`);
      });
    let [r, n, o = "", s = "", l = "", c = ""] = t.slice(1),
      f = "",
      d = c,
      p = d.split("/");
    if ((p.length > 1 && ((f = p.slice(0, -1).join("/")), (d = p.pop())), d)) {
      let e = d.match(/^\d+/);
      e && (d = e[0]);
    }
    return u({ host: s, pass: o, path: f, projectId: d, port: l, protocol: r, publicKey: n });
  }
  function u(e) {
    return {
      protocol: e.protocol,
      publicKey: e.publicKey || "",
      pass: e.pass || "",
      host: e.host,
      port: e.port || "",
      path: e.path || "",
      projectId: e.projectId,
    };
  }
  function c(e) {
    let t,
      r = e.getOptions(),
      { host: n } = e.getDsn() || {};
    return (
      r.orgId
        ? (t = String(r.orgId))
        : n &&
          (t = (function (e) {
            let t = e.match(o);
            return t?.[1];
          })(n)),
      t
    );
  }
  function f(e) {
    let t = "string" == typeof e ? l(e) : u(e);
    if (
      t &&
      (function (e) {
        if (!n.T) return !0;
        let { port: t, projectId: r, protocol: o } = e;
        return (
          !["protocol", "publicKey", "host", "projectId"].find(
            (t) => !e[t] && (a.Yz.error(`Invalid Sentry Dsn: ${t} missing`), !0),
          ) &&
          (r.match(/^\d+$/)
            ? "http" !== o && "https" !== o
              ? (a.Yz.error(`Invalid Sentry Dsn: Invalid protocol ${o}`), !1)
              : !(t && isNaN(parseInt(t, 10))) ||
                (a.Yz.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1)
            : (a.Yz.error(`Invalid Sentry Dsn: Invalid projectId ${r}`), !1))
        );
      })(t)
    )
      return t;
  }
}
